feedback_handler = {

    properties: {
        clickedLayer: '',
        newFeedbackPage: '',
        wordLimit: 1000,
        private: false
    },

    onLoad: function() {
        var self = this;

    },

    tipFollow: function(e) {
        $('#tip').css({
            left: e.pageX + 20,
            top: e.pageY - 12
        });
    },


    turnOn: function() {
        var self = this;
        self.turnOff();
        $(document).on("mousedown", ".commentLayer", feedback_handler.setupBox);
        $('body').addClass('adding-comment');
        $('.marker-input').addClass('animated bounceIn shake').removeClass('hidden');
        home_handler.hideSidebar();
        $(document).on('mousemove', self.tipFollow);
    },

    turnOff: function() {
        var self = this;
        $(document).off("mousedown", ".commentLayer", feedback_handler.setupBox);
        $('body').removeClass('adding-comment');
        $('.commentLayer #selectionMarquee').remove();
        $('.marker-input').addClass('hidden').removeClass('animated bounceIn shake');
        home_handler.showSidebar();
        $(document).off('mousemove', self.tipFollow);
    },

    clearNewData: function() {
        delete feedbackData.data.newData;
        $('.newComment').remove();
    },

    positionBox: function($box, coordinates) {
        $box.css(
            'top', coordinates.top + '%'
        ).css(
            'left', coordinates.left + '%'
        ).css(
            'height', coordinates.bottom - coordinates.top + '%'
        ).css(
            'width', coordinates.right - coordinates.left + '%'
        );
    },

    compareNumbers: function(a, b) {
        return a - b;
    },

    getBoxCoordinates: function(startX, startY, endX, endY) {
        var self = this;
        var x = [startX, endX].sort(self.compareNumbers),
            y = [startY, endY].sort(self.compareNumbers);

        return {
            top: y[0],
            left: x[0],
            right: x[1],
            bottom: y[1]
        };
    },

    trackMouse: function(event) {
        endX = (event.pageX - parentOffset.left) / $(this).width() * 100;
        endY = (event.pageY - parentOffset.top) / $(this).height() * 100;
        position = feedback_handler.getBoxCoordinates(startX, startY, endX, endY);

        if ((position.right - position.left) >= 1 && (position.bottom - position.top) >= 1) {
            mouseDragged = true;
        }

        $('.commentLayer #selectionMarquee').show().removeClass('hidden');
        feedback_handler.positionBox($('.commentLayer #selectionMarquee'), position);
    },


    commentMarker: function(x, y, id) {
        var div;
        if (id) {
            var highlight = (id == view_handler.properties.featureID) ? 'comment-selected' : '';
            div = $('<a id="comment-' + id + '" href="#/view/' + id + '" title="Click to view comment." class="commentMarker ' + highlight + '" style="position: absolute; left: ' + x + '%; top: ' + y + '%;"></a>');
        } else {
            div = $('<div class="commentMarker newComment blink_me" style="position: absolute; left: ' + x + '%; top: ' + y + '%;"></div>');
        }
        return div;
    },

    commentBox: function(x0, y0, x1, y1, id) {
        var $selectedBox;
        $('.commentLayer #selectionMarquee').hide();
        position = feedback_handler.getBoxCoordinates(x0, y0, x1, y1);
        if (position.left !== position.right && position.top !== position.bottom) {
            var selectBox;
            if (id) {
                var highlight = (id == view_handler.properties.featureID) ? 'comment-selected' : '';
                selectedBox = $('<div id="comment-' + id + '" class="selected-box ' + highlight + '"><a href="#/view/' + id + '" title="Click to view comment." class="box-title"></a></div>');
            } else {
                selectedBox = $('<div class="selected-box blink_me newComment"><div class="box-title"></div></div>');
            }

            // $( "div[data-page-number='"+page+"'] > .commentLayer" ).append(selectedBox);
            feedback_handler.positionBox(selectedBox, position);
            return selectedBox;
        }
    },

    commentMarkerPrint: function(x, y, id) {
        var div;
        if (id) {

            div = $('<div id="comment-' + id + '" class="commentMarker" style="position: absolute; left: ' + x + '%; top: ' + y + '%;">' + id + '</div>');
        }

        return div;
    },

    commentBoxPrint: function(x0, y0, x1, y1, id) {
        var $selectedBox;
        $('.commentLayer #selectionMarquee').hide();
        position = feedback_handler.getBoxCoordinates(x0, y0, x1, y1);
        if (position.left !== position.right && position.top !== position.bottom) {
            var selectBox;
            if (id) {
                selectedBox = $('<div id="comment-' + id + '" class="selected-box"><a class="box-title">' + id + '</a></div>');
            }

            feedback_handler.positionBox(selectedBox, position);
            return selectedBox;
        }
    },

    scrolltoComment: function(div) {
        var top = $(div).offset().top - $("#viewer").offset().top - 30;
        $('#viewerContainer').animate({
                scrollTop: top
            },
            800,
            "swing",
            function() {
                home_handler.showSidebar();
            }
        );
    },

    drawBox: function(e) {

        var divStorage;
        var div;
        var clickedLayer = feedback_handler.properties.clickedLayer;
        $(clickedLayer).off("mousemove", feedback_handler.trackMouse);
        $('body').off("mouseup", feedback_handler.drawBox);

        if (mouseDragged) {
            var page = $(clickedLayer).parent().attr('data-page-number');
            div = feedback_handler.commentBox(startX, startY, endX, endY);

            divStorage = {
                x: startX,
                y: startY,
                xx: endX,
                yy: endY,
                page: page,
                type: 'box'
            };

        } else if (!mouseDragged) {
            var parentOffset = $(clickedLayer).offset();
            var x = (e.pageX - parentOffset.left) / $(clickedLayer).width() * 100;
            var y = (e.pageY - parentOffset.top) / $(clickedLayer).height() * 100;
            var page = $(clickedLayer).parent().attr('data-page-number');
            var tipDirection = (x > 80) ? 'tipRight' : 'tipLeft';

            div = feedback_handler.commentMarker(x, y);



            divStorage = {
                x: x,
                y: y,
                xx: '',
                yy: '',
                page: page,
                type: 'point'
            };

        }

        $(clickedLayer).append(div);
        feedbackData.data.newData = divStorage;
        // feedback_handler.scrolltoComment(div);
        feedback_handler.turnOff();
        window.location.href = "#/feedback";
    },

    setupBox: function(event) {

        //Prevent Commenting over existing comments
        var target = $(event.target);
        if (target.hasClass('box-title') || target.hasClass('commentMarker')) {
            return false;
        }

        feedback_handler.properties.clickedLayer = this;

        $('.commentLayer #selectionMarquee').remove();
        $("#selectionMarquee").clone().appendTo(this);

        $(this).off("mousemove", feedback_handler.trackMouse);
        $('body').off("mouseup", feedback_handler.drawBox);

        parentOffset = $(this).offset();
        startX = (event.pageX - parentOffset.left) / $(this).width() * 100;
        startY = (event.pageY - parentOffset.top) / $(this).height() * 100;
        endX = '';
        endY = '';
        mouseDragged = false;

        var page = $(this).parent().attr('data-page-number');

        $(this).on('mousemove', feedback_handler.trackMouse);
        $('body').on('mouseup', feedback_handler.drawBox);
    },

    renderPrint: function(page, commentLayer, addLayer) {
        var hasComment = false;
        var self = this;
        var page = page + 1;
        //Add Markers and Boxes
        if (feedbackData.pages[page]) {
            $.each(feedbackData.data, function(index, value) {
                if (value.page == page) {
                    hasComment = true;
                    if (value.type == "point") {
                        div = self.commentMarkerPrint(value.x, value.y, value.id);
                        commentLayer.append(div);
                    } else if (value.type == "box") {
                        div = self.commentBoxPrint(value.x, value.y, value.xx, value.yy, value.id);
                        commentLayer.append(div);
                    }
                }
            });
        }

        //Add Comment Text
        if (hasComment) {
            var div = $('.printContainerData').clone().removeClass('printContainerData hidden');
            var comments = $('<div class="col-xs-12 printComments"><h1>Comments</h1></div>');

            $.each(feedbackData.data, function(index, value) {
                var id = value.id;
                if (value.page == page) {

                    var addComments = '';
                    //Adding in additional comments for feedback
                    $.each(feedbackData.comments, function(index, value) {
                        if (value.sid == id) {
                            addComments += '"' + value.comment + '" - ' + value.name + '<br>';
                        }
                    });

                    comments.append('<div class="margin-y"><b style="font-size:1.2em;">ID: ' + value.id + '</b><br>Comment: ' + value.comment + '<br>Likes: ' + value.likes + '</div>' + addComments + '<hr>');

                }
            });

            div.find('.row').append(comments);
            addLayer.append(div);
        }
    },

    //For web view. Not Print
    renderFeedback: function(page) {
        var self = this;
        var commentLayer = $('#commentLayer-' + page);
        var commentLayerExists = commentLayer.length || 0;

        if (feedbackData.pages[page] || feedbackData.data.newData) {
            $.each(feedbackData.data, function(index, value) {
                var div;
                var commentExists = $('#comment-' + value.id).length || 0;
                //Match Page
                if (value.page == page && !commentExists && commentLayerExists) {
                    if (value.type == "point") {
                        div = self.commentMarker(value.x, value.y, value.id);
                        commentLayer.append(div);
                    } else if (value.type == "box") {
                        div = self.commentBox(value.x, value.y, value.xx, value.yy, value.id);
                        commentLayer.append(div);
                    }
                }
            });
        }
    },

    getFeedback: function() {
        var self = this;
        self.clearNewData();

        if (self.properties.private === false) {
            $.ajax({
                type: "GET",
                url: properties.feedbackURL,
                cache: false,
                dataType: "json",
                success: function(json) {
                    $.each(json, function(index, value) {
                        if (index != "error" && feedbackData.data[value.id] == undefined) {
                            feedbackData.data[value.id] = value;
                            feedbackData.pages[value.page] = value.page;
                        }
                    });
    
                    self.renderFeedback(self.properties.newFeedbackPage);
                    self.properties.newFeedbackPage = '';
    
                    home_handler.showSidebar();
    
                    // if (properties.firstLoad === false){
                    //   firstLoad();
                    //   properties.firstLoad = true;
                    // }
    
                    if (properties.loadHash == 'view') {
                        properties.loadHash = '';
                        home_handler.getRequest();
                    }
    
                },
                error: function(xhr, textStatus, errorThrown) {}
            });
        }
    },

    addFeedback: function(event) {
        $('#submit').prop('disabled', true);

        var self = this;
        var underLimit = home_handler.wordCount($('textarea[name=comment]').val()) <= 1000;

        if (underLimit) {

            var fd = new FormData();
            var formData = {
                'name': home_handler.formatText($('input[name=name]').val()) || 'Anonymous',
                'comment': home_handler.formatText($('textarea[name=comment]').val()),
                'x': feedbackData.data.newData.x,
                'y': feedbackData.data.newData.y,
                'xx': feedbackData.data.newData.xx,
                'yy': feedbackData.data.newData.yy,
                'type': feedbackData.data.newData.type,
                'page': feedbackData.data.newData.page,
                created: 'date'
            };

            $.each(formData, function(key, value) {
                fd.append(key, value);
            });

            $.ajax({
                type: "POST",
                url: properties.feedbackURL,
                processData: false,
                contentType: false,
                crossDomain: false,
                data: fd,
                success: function(json) {
                    $('#submit').prop('disabled', false);
                    if (json.error) {
                        alert('Unable to complete your request at this time.');
                    } else {
                        self.properties.newFeedbackPage = feedbackData.data.newData.page
                        self.getFeedback();
                        window.location.href = "#/confirm";

                    }
                },
                error: function(xhr, textStatus, errorThrown) {
                    $('#submit').prop('disabled', false);
                    alert('error');

                }
            });
        } else {
            $('#submit').prop('disabled', false);
        }

        event.preventDefault();
    },



    events: function() {
        var self = this;


        $('.content-close-btn').click(function(event) {
            self.turnOff();
            self.clearNewData();
        });

        $("#comment-submit").submit(function(event) {
            self.addFeedback(event);
            return false;
        });

        $('textarea[name=comment]').on('input click', function() {
            var wordCount = home_handler.wordCount($(this).val());
            if (wordCount > self.properties.wordLimit) {
                $('.story-word').text(self.properties.wordLimit);
                $(this).addClass('required');
                $('.story-min').addClass('required');
            } else {
                $(this).removeClass('required');
                $('.story-min').removeClass('required');
                $('.story-word').text(wordCount);
            }
        });

    }
}
